import { accessToken } from './auth';

let account = null;

async function loadAccount() {
  const url = process.env.VUE_APP_GQL_API_URL;
  const body = {
    query: `query {
      account{
        userId
        defaultRole
        permissions
        allowedRoutes
        customFields
        mergeTags
        defaultDomain
        allowedDomains
      }
    }`,
  }
  const response = await fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken()}`
    },
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(body)
  });
  const responseBody = await response.json();
  const { data, errors } = responseBody;
  if (errors) {
    throw new Error(errors[0].message)
  }
  account = data.account
  return data.account
}

async function getAccount() {
  if (account === null) {
    return await loadAccount()
  } else {
    return account
  }
}

function getAccountSync() {
  return account
}

function getPermissions() {
  return account?.permissions || [];
}

function getAllowedRoutes() {
  return account?.allowedRoutes || [];
}

function isDebug() {
  if (localStorage.getItem('debug_mode') === 'oidsryeifhppdxwuahrzxdn') {
    return true
  }
  return false;
}

function eraseAccount() {
  account = null;
}

export {
  loadAccount,
  getAccount,
  getAccountSync,
  getPermissions,
  getAllowedRoutes,
  eraseAccount,
  isDebug
}